import { useEffect, useState } from "react";
import { FlaskConical } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

const fmt = (iso) => {
  const [y, m, d] = (iso || "").split("-");
  return y && m && d ? `${d}/${m}/${y}` : "—";
};

export const DemoBanner = () => {
  const { user } = useAuth();
  const [info, setInfo] = useState(null);
  useEffect(() => {
    if (!user?.tenant_id) return;
    api.get("/studio/demo-info").then(({ data }) => setInfo(data)).catch(() => setInfo(null));
  }, [user?.tenant_id]);
  if (!info?.demo) return null;
  return (
    <div className="flex items-center gap-2 px-6 lg:px-10 py-2 bg-amber-100 border-b border-amber-300 text-amber-900 text-sm" role="alert" data-testid="demo-banner">
      <FlaskConical className="h-4 w-4 shrink-0" />
      <span data-testid="demo-banner-text">
        Stai usando una versione demo. I dati che inserisci saranno cancellati automaticamente dopo {info.retention_days} giorni. La demo scade il {fmt(info.scadenza)}.
      </span>
    </div>
  );
};
